export default "__VITE_ASSET__S3BLb0vR__"